import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ isAuthenticated, children }) => {
  return (isAuthenticated?.logged_in ) ? (isAuthenticated?.bettingOn==='1' || isAuthenticated?.isHome )?children:<Navigate to={"/home"} replace /> : <Navigate to={"/login"} replace />;
};

export default ProtectedRoute;